import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Users } from "../API/Users";
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  value: string | null;
  setGroup: Function;
  validationGroup: boolean;
};

export default function GroupInput({
  value,
  setGroup,
  validationGroup,
}: Props) {
  const userAPI = useMemo(() => new Users(), []);
  const [data, setData] = useState([]);

  useEffect(() => {
    userAPI.getGroups().then((response) => {
      const _groups = response.data.groups;
      _groups.sort()
      setData(_groups);
    });
  }, [userAPI]);

  const [showNewClient, setShowNewClient] = useState(false);

  const onChangeNewClient = useCallback(
    (e: any) => {
      const text = e.target.value;
      setGroup(text);
    },
    [setGroup]
  );
  const onSelectClient = useCallback(
    (e: any) => {
      setGroup(e.target.value);
    },
    [setGroup]
  );
  return (
    <Box display={"flex"} width={"100%"} gap={1}>
      <FormControl sx={{ flex: 1, width: "100%" }} error={validationGroup}>
        {!showNewClient && (
          <InputLabel shrink={true} color="secondary" size={"small"}>
            <Typography>Client</Typography>
          </InputLabel>
        )}
        {showNewClient ? (
          <TextField
            error={validationGroup}
            fullWidth
            autoFocus
            label={"Client"}
            color="secondary"
            placeholder="Insert a client"
            onChange={onChangeNewClient}
            size="small"
            helperText={validationGroup && "Choose or insert new client"}
          />
        ) : (
          <Select
            error={validationGroup}
            label={"Client"}
            slotProps={{ input: { color: "secondary" } }}
            fullWidth
            onChange={onSelectClient}
            size="small"
            value={value ?? "-"}
          >
            <MenuItem disabled value={"-"} key={"-"}>
              Select client
            </MenuItem>
            {data.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>

      {showNewClient ? (
        <IconButton
          onClick={() => {
            setShowNewClient(false);
            setGroup(null);
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : (
        <IconButton
          sx={{ borderRadius: "6px" }}
          title="Add new client"
          onClick={() => setShowNewClient(true)}
        >
          <AddIcon />
          <Typography sx={{ fontSize: "0.6vw" }}>Add New</Typography>
        </IconButton>
      )}
    </Box>
  );
}
